export default __webpack_public_path__ + "static/media/Logo-BAA.dc91957b.png";